<template>
  <article>
    <header role="banner">
      <nav-bar :center=true>
        <nav-link to="/" name="Home"></nav-link>
        <nav-link v-for="{link,linkName} in navLinks" :to="link"
                  :name="linkName" :key="link"></nav-link>
      </nav-bar>
    </header>
    <main class="flex-fill" style="margin-top:2em">
      <slot></slot>
    </main>
    <footer class="footer text-center">
      <small data-nosnippet>Extrém I. &copy; 2020</small>
    </footer>
  </article>
</template>

<script>
// import VLink from './../components/VLink.vue'
import NavLink from "../components/bootstrap/NavLink.vue";
import NavBar from "../components/bootstrap/NavBar.vue";

export default {
  props: ['links', 'title'],
  components: {
    NavLink,
    NavBar
  },
  data: function () {
    // console.log(this.links);
    if (this.title) {
      window.document.title = this.title;
    }
    return {
      navLinks: this.links,
      // newTitle: this.title,
    }
  }

}
</script>

<style scoped>

html, body {
  width: 100%;
  height: 100%;
}

article {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

main {
  flex-grow: 1;
}

.footer {
  height: 24px; /* Set the fixed height of the footer here */
  line-height: 24px; /* Vertically center the text there */
}

header, main, footer {
  flex-shrink: 0;
}
</style>